export default __webpack_public_path__ + "static/media/xiaohongshu.362a5805.jpg";